import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=98eb8004&scoped=true&"
import script from "./FaqModal.vue?vue&type=script&lang=js&"
export * from "./FaqModal.vue?vue&type=script&lang=js&"
import style0 from "./FaqModal.vue?vue&type=style&index=0&id=98eb8004&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eb8004",
  null
  
)

export default component.exports